import styled from 'styled-components';
import React, { useMemo, useState } from 'react';
import { useAvatarUpload } from './useAvatarUpload';
import {
  AvatarHistoryColHeader,
  Header,
  TableActionsHeader,
  AvatarRow,
} from '../../components/AvatarUpload';
import Loading from '../../components/Loading';
import { NoItemsView } from '../../components/Organisations';
import {
  AVATAR_NOT_FOUND,
  NO_AVATAR_HISTORY_TITLE,
  OOPS_SOMETHING_WENT_WRONG_MESSAGE,
} from '../../utils/constants';
import { AvatarUploadContext } from '../../components/AvatarUpload/context';
import { AvatarDeleteModal } from '../../components/AvatarUpload/AvatarDeleteModal/AvatarDeleteModal';

const AvatarUpload = () => {
  const {
    avatarHistory,
    loading,
    error,
    filters,
    hasSelectedFilter,
    deleteModal,
    selectedAvatarFileIds,
    onFilterChange,
    resetFilters,
    onRefresh,
    onAvatarDelete,
    isAvatarDeleteModalOpen,
    areAllSelected,
    toggleAvatarDeleteModal,
    getDeleteAvatarModalDetails,
    toggleAvatar,
  } = useAvatarUpload();

  const values = useMemo(
    () => ({
      filters,
      deleteModal,
      selectedAvatarFileIds,
      onFilterChange,
      resetFilters,
      onAvatarDelete,
      toggleAvatar,
      onRefresh,
      areAllSelected,
    }),
    [filters, deleteModal, selectedAvatarFileIds, areAllSelected],
  );

  const [showFilter, setShowFilter] = useState(false);

  return (
    <AvatarUploadContext.Provider value={values}>
      {isAvatarDeleteModalOpen && (
        <AvatarDeleteModal
          {...getDeleteAvatarModalDetails()}
          isOpen={isAvatarDeleteModalOpen}
          onClose={toggleAvatarDeleteModal}
        />
      )}
      <Header />
      <StyledTable>
        <TableActionsHeader
          onRefresh={onRefresh}
          showFilter={showFilter}
          toggleFilter={setShowFilter}
        />
        <AvatarHistoryColHeader />
        {loading && <Loading className="loading" />}
        {error && <NoItemsView title={OOPS_SOMETHING_WENT_WRONG_MESSAGE} />}

        {!loading && !error && (
          <StyledBody isFilterOpen={showFilter}>
            {avatarHistory.length === 0 ? (
              <NoItemsView
                title={
                  hasSelectedFilter ? AVATAR_NOT_FOUND : NO_AVATAR_HISTORY_TITLE
                }
                description=""
              />
            ) : (
              avatarHistory.map((item) => (
                <AvatarRow key={item.id} item={item} />
              ))
            )}
          </StyledBody>
        )}
      </StyledTable>
      <div id="avatar-upload-toast" />
    </AvatarUploadContext.Provider>
  );
};

export default AvatarUpload;

export const StyledTable = styled.div`
  background: white;
  border-radius: 10px;
  height: 80vh;

  .loading,
  .empty-message-view {
    height: 80%;
  }
`;

export const StyledBody = styled.div<{ isFilterOpen: boolean }>`
  height: calc(100% - ${(props) => (props.isFilterOpen ? '250px' : '150px')});
  overflow: auto;
`;
